'use strict';
function _typeof(t) {
    return (_typeof = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (t) {
        return typeof t;
    } : function (t) {
        return t && 'function' == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? 'symbol' : typeof t;
    })(t);
}
Object.defineProperty(exports, '__esModule', { value: !0 }), exports.wapactPageCount = exports.videoAppPageCount = exports.userkeyUtil = exports.sharefrom = exports.mos = exports.cookieUtil = exports.h5PageCount = void 0;
var stadigurl = 'https://stadig.ifeng.com/appsta.js?datatype=newsappsns', videoAppStadigurl = 'http://stadig.ifeng.com/appsta.js?datatype=videoappsns', ua = 'object' === ('undefined' == typeof navigator ? 'undefined' : _typeof(navigator)) ? navigator.userAgent : '', cookieUtil = {
        set: function (t, o, e, n, a, c) {
            var r = ''.concat(encodeURIComponent(t), '=').concat(encodeURIComponent(o));
            e instanceof Date && (r = ''.concat(r, ';expires=').concat(e.toGMTString())), n && (r = ''.concat(r, ';path=').concat(n)), a && (r = ''.concat(r, ';domain').concat(a)), c && (r = ''.concat(r, ';secure')), document.cookie = r;
        },
        get: function (t) {
            var o = ''.concat(encodeURIComponent(t), '='), e = document.cookie.indexOf(o), n = null;
            if (-1 < e) {
                var a = document.cookie.indexOf(';', e);
                -1 === a && (a = document.cookie.length), n = document.cookie.substring(e + o.length, a), n = decodeURIComponent(n);
            }
            return n;
        }
    };
exports.cookieUtil = cookieUtil;
var mos = function () {
    return ua.match(/iphone|ipod/gi) || ua.match(/ipad/gi) ? 'iphone' : ua.match(/android/gi) ? 'android' : 'windows';
};
exports.mos = mos;
var userkeyUtil = {
    get: function (t) {
        for (var o = t || 32, e = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678', n = e.length, a = '', c = 0; c < o; c++)
            a += e.charAt(Math.floor(Math.random() * n));
        return a;
    },
    init: function () {
        if (cookieUtil.get('userkey'))
            return cookieUtil.get('userkey');
        var t = userkeyUtil.get(15), o = new Date();
        return o.setTime(o.getTime() + 2592000000), cookieUtil.set('userkey', t, o, '/'), t;
    }
};
exports.userkeyUtil = userkeyUtil;
var sharefrom = function () {
    return ua.match(/MicroMessenger/gi) ? 'wx' : ua.match(/QQ\//) ? 'qq' : ua.match(/WeiBo/i) ? 'weibo' : 'unknown';
};
exports.sharefrom = sharefrom;
var format = function (t) {
        return 9 < t ? t : '0'.concat(t);
    }, timestamp = function () {
        var t = new Date(), o = t.getFullYear(), e = format(t.getMonth() + 1), n = format(t.getDate()), a = format(t.getHours()), c = format(t.getMinutes()), r = format(t.getSeconds()), i = ''.concat(o, '-').concat(e, '-').concat(n, '+').concat(a, ':').concat(c, ':').concat(r);
        return t ? i : '';
    }, session = function (t, o, e) {
        var n = o ? 'type='.concat(o) : '', a = '';
        if ('object' == _typeof(e)) {
            var c = e;
            for (var r in c)
                a += '$'.concat(r, '=').concat(c[r]);
        }
        return ''.concat(timestamp(), '#').concat(t, '#').concat(n).concat(a);
    }, h5PageCount = function (t, o) {
        var e = [];
        t.forEach(function (t) {
            t && t.datatype && (stadigurl = 'https://stadig.ifeng.com/appsta.js?datatype='.concat(t.datatype)), e.push(session(t.behavior, t.type, t.other));
        });
        var n = e.join('@'), a = o || sharefrom(), c = ''.concat(stadigurl, '&mos=').concat(mos(), '&userkey=').concat(userkeyUtil.init(), '&ua=&share=').concat(a, '&session=').concat(encodeURIComponent(n)), r = document.createElement('script');
        r.src = c, r.async = 'async', document.body.appendChild(r);
    };
exports.h5PageCount = h5PageCount;
var videoAppPageCount = function (t) {
    var o = [];
    t.forEach(function (t) {
        o.push(session(t.behavior, t.type, t.other));
    });
    var e = o.join('@'), n = ''.concat(videoAppStadigurl, '&mos=').concat(mos(), '&userkey=').concat(userkeyUtil.init(), '&ua=&share=').concat(sharefrom(), '&session=').concat(encodeURIComponent(e)), a = document.createElement('script');
    a.src = n, a.async = 'async', document.body.appendChild(a);
};
exports.videoAppPageCount = videoAppPageCount;
var wapactPageCount = function (t) {
    var o = t.value || '', e = encodeURIComponent(location.href) || '', n = encodeURIComponent(document.referrer) || '', a = cookieUtil.get('userid') || '', c = t.sid || '', r = new Date().getTime(), i = t.ci || '', s = t.pt || '', p = t.method || 'post', u = 'datatype=wap_act&value='.concat(o, '&uri=').concat(e, '&ref=').concat(n, '&uid=').concat(a, '&sid=').concat(c, '&time=').concat(r, '&ci=').concat(i, '&pt=').concat(s), d = document.createElement('script');
    d.src = ''.concat('https://stadig.ifeng.com/actsta.js', '?').concat(u), d.async = 'async', 'get' === p && document.body.appendChild(d), 'post' === p && navigator && navigator.sendBeacon ? navigator.sendBeacon('https://stadig0.ifeng.com/actsta.js', u) : document.body.appendChild(d);
};
exports.wapactPageCount = wapactPageCount;